/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/AccessAnalyticsDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessAnalyticsDashboardTestIds = {
  accessAnalyticsDashboardPage: "access-analytics-dashboard-page",
  cardTitleTopIdentities: "card-title-top-identities",
  cardTitleTopSystems: "card-title-top-systems",
  colGrants: "col-grants",
  colIdentity: "col-identity",
  colSystem: "col-system",
  filterPeriod: "filter-period",
  inputAnalyticsFrom: "input-analytics-from",
  inputAnalyticsTo: "input-analytics-to",
  linkIdentitiesWithGrants: "link-identities-with-grants",
  linkTargetSystems: "link-target-systems",
  linkIdentityDetail: (identity_id: string) => `link-identity-detail-${identity_id}`,
  linkIdentityDetailPrefix: () => "link-identity-detail-" as TestIdPrefix,
  linkSystemDetail: (system_id: string) => `link-system-detail-${system_id}`,
  linkSystemDetailPrefix: () => "link-system-detail-" as TestIdPrefix
} as const;
